import axios from "axios";

import Config from "./Config";
import APIHelper from "./APIHelper";

class WalmartService {
    static WALMART_ID = 218;
    static #walmartWebsites = null;

    static Inject(list) {
        WalmartService.#walmartWebsites = list;
    }

    static Load(list = null) {
        return new Promise((resolve, reject) => {
            if (list !== null) {
                WalmartService.#walmartWebsites = list;
                resolve(WalmartService.#walmartWebsites);
                return;
            }
            if (WalmartService.#walmartWebsites === null) {
                axios
                    .get(`${Config.API_URL}website/walmart`)
                    .then((response) => {
                        if (APIHelper.checkStatus(response)) {
                            WalmartService.#walmartWebsites =
                                response.data.items;
                            resolve(WalmartService.#walmartWebsites);
                            return;
                        }
                        reject();
                    })
                    .catch(reject);
            } else {
                resolve(WalmartService.#walmartWebsites);
            }
        });
    }

    /**
     * Should return a list of Walmart websites filtered by country ID. If the country ID is not found,
     * it should include Walmart.com website among results.
     */
    static async FilterByCountryID(countryID) {
        return await WalmartService.Load()
            .then((items) => {
                const filter =
                    typeof countryID === "number" ? [countryID] : countryID;
                let walmartComIsAmongResult = false,
                    walmartProfile,
                    filteredList = items.filter((website) => {
                        const shouldInclude =
                            filter.indexOf(website.country_id) !== -1;
                        if (website.id === WalmartService.WALMART_ID) {
                            walmartProfile = website;
                            if (shouldInclude) {
                                walmartComIsAmongResult = true;
                            }
                        }
                        return shouldInclude;
                    }),
                    missingCountries = filter.length - filteredList.length > 0;

                return missingCountries && !walmartComIsAmongResult
                    ? [walmartProfile, ...filteredList]
                    : filteredList;
            })
            .catch(() => false);
    }
}

export default WalmartService;
